import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot, UrlTree } from '@angular/router';

@Injectable({
  providedIn: 'root'
})
export class QueryParamGuard {

  constructor(private router: Router) {}

  canActivate(
    route: ActivatedRouteSnapshot,
    _state: RouterStateSnapshot
  ): boolean | UrlTree {
    const requiredParam = route.data['requiredQueryParam'] as string;
    if (requiredParam && route.queryParamMap.has(requiredParam)) {
      return true;
    }
    return this.router.createUrlTree(['/']);
  }
}
